import * as React from 'react';

import {SaveButton} from 'shells/button/save-button/save-button';

import styles from './conferencing-modal-wrapper.module.css';

type Props = {
    onSave: () => void | null | undefined;
    closeModal: () => void;
};

export function DoneButton(props: Props) {
    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    const handleClick = () => {
        if (props.onSave) {
            setIsSaving(true);
            props.onSave();

            setTimeout(() => {
                setIsSaving(false);
                props.closeModal();
            }, 1000);
        } else {
            props.closeModal();
        }
    };

    return (
        <div className={styles['done-button']}>
            {/* @ts-expect-error */}
            <SaveButton size='big' onClick={handleClick} isSaving={isSaving} buttonText='Done' />
        </div>
    );
}
